import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Theme from '@/layouts/Theme'
import Layout from '@/layouts/shells'
import mockServer from './testing'
import appConfig from '@/configs/app.config'
import AppErrorBoundary from '@/components/shared/AppErrorBoundary'
import '@/features/base/language-management/locales'

const environment = process.env.NODE_ENV

/**
 * Set enableMock(Default false) to true at configs/app.config.js
 * If you wish to enable mock api
 */
if (environment !== 'UT' && environment !== 'IT' && appConfig.enableMock) {
    mockServer({ environment })
}
function AppContent() {
    return (
        <Theme>
            <Layout />
        </Theme>
    )
}

function App() {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor} loading={null}>
                <BrowserRouter>
                    <AppErrorBoundary>
                        <AppContent />
                    </AppErrorBoundary>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

export default App
